"use strict";

define('navigation',[], function () {
    "use strict";

    var initialized = false;

    var Plugin = {
        initialize: function initialize() {
            if (initialized) {
                return;
            }

            // grab an element
            var mobileActions = document.querySelectorAll('.hrjs');

            // construct an instance of Headroom, passing the element
            mobileActions.forEach(function (elem) {
                var headroom = new Headroom(elem, {
                    "tolerance": {
                        up: 5,
                        down: 5
                    }
                });
                headroom.init();
            });

            var toggleMenu = document.getElementById('dcf-menu-toggle');
            var mobileNav = document.getElementById('dcf-navigation');
            var modalParent = toggleMenu.closest('.dcf-modal-parent');
            var body = document.querySelector('body');
            var firstLink = mobileNav.querySelector('a');

            function onKeyUp(e) {
                if (e.keyCode === 27) {
                    closeModal();
                }
            }

            function openModal() {
                body.classList.remove('dcf-overflow-auto');
                body.classList.add('dcf-overflow-hidden');
                modalParent.classList.add('dcf-modal-open');
                toggleMenu.setAttribute('aria-expanded', 'true');
                firstLink.focus();
                modalParent.addEventListener('keyup', onKeyUp);
            }

            function closeModal() {
                body.classList.remove('dcf-overflow-hidden');
                body.classList.add('dcf-overflow-auto');
                modalParent.classList.remove('dcf-modal-open');
                toggleMenu.setAttribute('aria-expanded', 'false');
                toggleMenu.focus();
                modalParent.removeEventListener('keyup', onKeyUp);
            }

            toggleMenu.addEventListener('click', function () {
                if (modalParent.classList.contains('dcf-modal-open')) {
                    closeModal();
                } else {
                    openModal();
                }
            });
        }
    };

    return Plugin;
});

